<script setup>
const copyFailTip = ref(false);
const content = ref({
  url: "",
  only_url: "",
  tip: "",
});
function show(data) {
  copyFailTip.value = true;
  content.value = data;
}
defineExpose({
  show,
});
</script>

<template>
  <div>
    <el-dialog
      v-model="copyFailTip"
      title="提示"
      width="700px"
      align-center
      draggable
      style="border-radius: 10px"
    >
      <template #header>
        <span style="display: flex; align-items: center"
          ><el-icon size="20" color="#507aec"><InfoFilled /></el-icon
          ><span style="font-size: 16px; margin-left: 5px">提示</span></span
        >
      </template>
      <div style="margin: 10px 0">
        <b>当前浏览器无权限复制，请手动复制下面邀请内容</b>
      </div>
      <div class="bordered">
        <el-text type="primary">{{ content.only_url }}</el-text>
        {{ content.tip }}
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="copyFailTip = false"> 返回 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<style scoped>
.bordered {
  border: 1px solid var(--el-border-color);
  padding: 10px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
}
</style>
